import { Button, toast } from "@win-reality/react-ui";

import { useChallengeSubmission } from "../hooks/useChallengeSubmission";

interface ChallengeButtonProps {
  size?: "sm" | "lg";
}

export const ChallengeButton = ({ size = "sm" }: ChallengeButtonProps) => {
  const { isPending, mutate } = useChallengeSubmission();

  const isLarge = size === "lg";

  const handleClick = () => {
    toast("Challenge sent", { variant: "success" });
    mutate();
  };

  return (
    <Button
      onClick={handleClick}
      isDisabled={isPending}
      className={
        isLarge
          ? "mt-8 w-full rounded-full px-8 py-8 text-lg font-semibold text-white hover:brightness-110"
          : "rounded-full hover:brightness-110"
      }
      style={{
        backgroundColor: "#F44336",
        color: "white",
      }}
    >
      Challenge
    </Button>
  );
};
